import { cva } from "class-variance-authority"

export type ControlSize = "inline" | "sm" | "default" | "lg"

export const controlSize = cva("", {
  variants: {
    size: {
      inline: "h-auto py-0",
      sm: "h-7",
      default: "h-8",
      lg: "h-10",
    },
  },
  defaultVariants: {
    size: "default",
  },
})

export const CONTROL_SURFACE =
  "w-full rounded-md border border-input bg-background px-3 text-body-regular ring-offset-background disabled:cursor-not-allowed disabled:opacity-50"
